export default ({ app }) => {
  app.i18n.pluralizationRules = {
    ga (number, choiceIndex) {
      if (number === 0) {
        return 0;
      }
      if (number === 1) {
        return 1;
      }
      if (number < 7) {
        return 2;
      }
      if (number < 10) {
        return 3;
      }
      if (number < 12) {
        return 4;
      }
      if (number % 10 < 6) {
        return 2;
      }
      return 3;
    }
  };
};
